// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1P6tU","footer":"ModalInfo_footer__1pYdo"};